export default "__VITE_ASSET__CR5F2wzB__"